import React from 'react';
import { companyInfo } from '../data/mock';

const AGB = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold text-white mb-4">Allgemeine Geschäftsbedingungen</h1>
          <p className="text-slate-300">AGB der {companyInfo.name}</p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-slate max-w-none">
            <h2 className="text-2xl font-semibold text-slate-900 mb-4">§ 1 Geltungsbereich</h2>
            <p className="text-slate-600 mb-6">
              (1) Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für alle Verträge zwischen der {companyInfo.name}, 
              vertreten durch {companyInfo.owner}, {companyInfo.address} (nachfolgend "Auftragnehmer") und dem Kunden 
              (nachfolgend "Auftraggeber") über die Erstellung von Webseiten, Webanwendungen und damit verbundenen 
              Dienstleistungen.
              <br /><br />
              (2) Abweichende, entgegenstehende oder ergänzende Allgemeine Geschäftsbedingungen des Auftraggebers 
              werden nur dann Vertragsbestandteil, wenn der Auftragnehmer ihrer Geltung ausdrücklich schriftlich 
              zugestimmt hat.
            </p>

            <h2 className="text-2xl font-semibold text-slate-900 mb-4 mt-8">§ 2 Vertragsgegenstand</h2>
            <p className="text-slate-600 mb-6">
              (1) Der Auftragnehmer erbringt Leistungen im Bereich Webdesign, Webentwicklung, App-Entwicklung und 
              damit zusammenhängende Beratungs- und Supportleistungen.
              <br /><br />
              (2) Art und Umfang der Leistungen ergeben sich aus dem jeweiligen Angebot bzw. der Auftragsbestätigung 
              des Auftragnehmers.
            </p>

            <h2 className="text-2xl font-semibold text-slate-900 mb-4 mt-8">§ 3 Angebot und Vertragsschluss</h2>
            <p className="text-slate-600 mb-6">
              (1) Angebote des Auftragnehmers sind freibleibend und unverbindlich, sofern nicht ausdrücklich etwas 
              anderes vereinbart wurde.
              <br /><br />
              (2) Der Vertrag kommt durch die schriftliche Auftragsbestätigung des Auftragnehmers oder durch die 
              Aufnahme der Leistungserbringung zustande.
            </p>

            <h2 className="text-2xl font-semibold text-slate-900 mb-4 mt-8">§ 4 Preise und Zahlungsbedingungen</h2>
            <p className="text-slate-600 mb-6">
              (1) Es gelten die im Angebot genannten Preise. Alle Preise verstehen sich zuzüglich der gesetzlichen 
              Mehrwertsteuer.
              <br /><br />
              (2) Bei größeren Projekten ist eine Anzahlung in Höhe von 50% der Auftragssumme bei Auftragserteilung 
              fällig. Die Restzahlung erfolgt nach Fertigstellung und Abnahme des Projekts.
              <br /><br />
              (3) Rechnungen sind innerhalb von 14 Tagen nach Rechnungsstellung ohne Abzug zahlbar.
            </p>

            <h2 className="text-2xl font-semibold text-slate-900 mb-4 mt-8">§ 5 Mitwirkungspflichten des Auftraggebers</h2>
            <p className="text-slate-600 mb-6">
              (1) Der Auftraggeber stellt dem Auftragnehmer alle für die Durchführung des Auftrags erforderlichen 
              Materialien, Daten und Informationen rechtzeitig zur Verfügung.
              <br /><br />
              (2) Der Auftraggeber benennt einen Ansprechpartner, der für den Auftragnehmer verbindliche Entscheidungen 
              treffen kann.
              <br /><br />
              (3) Der Auftraggeber prüft die vom Auftragnehmer erbrachten Leistungen unverzüglich und teilt etwaige 
              Mängel umgehend mit.
            </p>

            <h2 className="text-2xl font-semibold text-slate-900 mb-4 mt-8">§ 6 Urheberrecht und Nutzungsrechte</h2>
            <p className="text-slate-600 mb-6">
              (1) Der Auftragnehmer räumt dem Auftraggeber mit vollständiger Zahlung des vereinbarten Honorars das 
              ausschließliche Nutzungsrecht an den erstellten Werken für den vereinbarten Verwendungszweck ein.
              <br /><br />
              (2) Das Urheberrecht an den erstellten Werken verbleibt beim Auftragnehmer.
              <br /><br />
              (3) Der Auftragnehmer ist berechtigt, die erstellten Werke zu Präsentationszwecken im eigenen Portfolio 
              zu verwenden.
            </p>

            <h2 className="text-2xl font-semibold text-slate-900 mb-4 mt-8">§ 7 Gewährleistung und Haftung</h2>
            <p className="text-slate-600 mb-6">
              (1) Der Auftragnehmer gewährleistet, dass die erbrachten Leistungen frei von Mängeln sind, die den 
              vereinbarten Verwendungszweck aufheben oder erheblich mindern.
              <br /><br />
              (2) Die Gewährleistungsfrist beträgt 12 Monate ab Abnahme.
              <br /><br />
              (3) Die Haftung des Auftragnehmers ist auf Vorsatz und grobe Fahrlässigkeit beschränkt.
            </p>

            <h2 className="text-2xl font-semibold text-slate-900 mb-4 mt-8">§ 8 Schlussbestimmungen</h2>
            <p className="text-slate-600 mb-6">
              (1) Es gilt das Recht der Bundesrepublik Deutschland.
              <br /><br />
              (2) Gerichtsstand ist der Sitz des Auftragnehmers.
              <br /><br />
              (3) Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder werden, bleibt die Wirksamkeit der 
              übrigen Bestimmungen davon unberührt.
            </p>

            <p className="text-slate-500 text-sm mt-8">
              Stand: {new Date().toLocaleDateString('de-DE', { month: 'long', year: 'numeric' })}
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AGB;
